export default "__VITE_ASSET__B5onVwxn__ 100w";